// ============================================================
// FieldError.tsx
// Small inline error message shown below an invalid field
// ============================================================
import React from 'react'
interface FieldErrorProps {
  message?: string
}
const FieldError: React.FC<FieldErrorProps> = ({ message }) => {
  if (!message) return null
  return <p className="text-xs text-casevo-danger mt-1">{message}</p>
}
export default FieldError
